import axios, { type AxiosError } from "axios";
import { z } from "zod";

export namespace RestUtils {
  export const doesServerErrorMessageContain = (e: AxiosError, text: string): boolean => {
    const message = extractServerErrorMessage(e);
    if (message == null) {
      return false;
    }

    return message.toLowerCase().includes(text.toLowerCase());
  };

  export const extractServerErrorMessage = (e: unknown): string | null => {
    if (e instanceof z.ZodError) {
      return e.message;
    }

    if (!axios.isAxiosError(e)) {
      return null;
    }

    if (!e.response) {
      return null;
    }

    const data = e.response.data as { message: unknown } | undefined;

    if (typeof data?.message === "string") {
      return data.message;
    }

    return null;
  };

  export const extractValidationErrors = (e: unknown): Record<string, string[]> | null => {
    if (!axios.isAxiosError(e)) {
      return null;
    }

    const data = e.response?.data as { errors: Record<string, { message: string }[]> } | undefined;

    if (data?.errors) {
      return Object.fromEntries(Object.entries(data.errors).map(([key, value]) => [key, value.map((v) => v.message)]));
    }

    return null;
  };
}
